import React from 'react';
import { Trans } from 'react-i18next';
import { SongInsights } from '../../Dashboard';
import { getStationNameList } from '../SmartInsightsCardContentHelper';

// 3. Rotation card content logic
export const getRotationCardContent = (
  songInsights: SongInsights,
  isHovering = false
): React.ReactNode => {
  if (isHovering) {
    return <Trans i18nKey="ROTATION_HOVER" components={{ bold: <strong /> }} />;
  }
  const rotations = songInsights?.songInsightsData?.stations_on_rotation;
  if (rotations) {
    const { items, last } = getStationNameList(
      rotations.map((r) => r.radio_station_name)
    );
    if (rotations.length > 0) {
      if (rotations.length < 4) {
        const groupKey =
          rotations.length === 1
            ? 'ROTATION_SINGLE_STATION'
            : 'ROTATION_SOME_STATION';
        return (
          <Trans
            i18nKey={groupKey}
            values={{
              station: items,
              lastStation: last,
            }}
            components={{ bold: <strong /> }}
          />
        );
      }
      if (rotations.length >= 4) {
        return (
          <Trans
            i18nKey="ROTATION_MULTI_STATIONS"
            values={{
              stationlist: items,
              lastStation: last,
              number: rotations.length - 3,
            }}
            components={{ bold: <strong /> }}
          />
        );
      }
    }
  }
  return null;
};
